import { ComponentProps, ReactNode } from 'react'

import { cn } from '@/shared/lib'

import { FilterChip } from './chip'

type Props = {
  className?: string
  children: ReactNode
}

export const Title = ({ className, children }: Props) => {
  return (
    <h3 className={cn('typo-body1 mb-3 font-semibold text-black', className)}>
      {children}
    </h3>
  )
}

export const SubTitle = ({ className, children }: Props) => {
  return (
    <h4
      className={cn(
        'typo-label1 mb-2 font-semibold text-purple-500',
        className,
      )}
    >
      {children}
    </h4>
  )
}

export const Description = ({ className, children }: Props) => {
  return (
    <p className={cn('typo-label2 font-normal text-gray-500', className)}>
      {children}
    </p>
  )
}

export const List = ({ className, children }: Props) => {
  return <ul className={cn('flex flex-wrap gap-2', className)}>{children}</ul>
}

export const Item = ({
  children,
  ...restProps
}: ComponentProps<typeof FilterChip> & Props) => {
  return (
    <li className="flex flex-wrap gap-2">
      <FilterChip {...restProps}>{children}</FilterChip>
    </li>
  )
}
